/**
 * @generated SignedSource<<94699ace7d16a5cf9ee851eae31f8992>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentModuleReleaseDateFragment$data = {
  readonly id: string;
  readonly releasedAt: string | null;
  readonly " $fragmentType": "ContentModuleReleaseDateFragment";
};
export type ContentModuleReleaseDateFragment$key = {
  readonly " $data"?: ContentModuleReleaseDateFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentModuleReleaseDateFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentModuleReleaseDateFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "releasedAt",
      "storageKey": null
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};

(node as any).hash = "32d006424ee46e60a75380c5e5354bf6";

export default node;
